import { handleObjProps } from "./handleObjProps";
export function setColorBG(element, color) {
    let colorValue = "linear-gradient(-45deg, rgba(68,148,221,1) 0%, rgba(83,182,190,1) 100%)";
    // TODO: Something here isn't right, it's overriding one and the other
    colorValue = "rgb(17 49 80)";
    if (color === "white") {
        colorValue = "#fff";
    }
    else if (color) {
        colorValue = color;
    }
    handleObjProps("background", { color: colorValue }, element);
}
